import { SvgIconComponent } from '@mui/icons-material';

interface SectionHeaderProps {
  title: string;
  icon: SvgIconComponent;
  colorClass: string;
  subtitle?: string;
}

const SectionHeader = ({ title, icon: Icon, colorClass, subtitle }: SectionHeaderProps) => (
  <div className='flex items-center gap-3 mb-6 px-1'>
    <div className={`p-2.5 rounded-xl ${colorClass} shadow-sm aspect-square flex items-center justify-center`}>
      <Icon sx={{ fontSize: 24, color: 'white', opacity: 0.9 }} />
    </div>
    <div className='flex flex-col'>
      <h3 className='text-xl font-black text-gray-800 leading-tight'>{title}</h3>
      {subtitle && (
        <span className='text-[13px] text-gray-400 font-medium leading-tight mt-0.5'>
          {subtitle}
        </span>
      )}
    </div>
  </div>
);

export default SectionHeader;
